export const firebaseAPIKey = process.env.REACT_APP_FIREBASE_API_KEY;
export const resourceAPIURL = process.env.REACT_APP_RESOURCE_API_URL;

function parseTimeoutMs(
  value: string | undefined,
  fallbackMs: number
): number {
  const parsed = parseInt(value || String(fallbackMs), 10);
  return Number.isFinite(parsed) && parsed > 0 ? parsed : fallbackMs;
}

/** Default timeout for JSON API requests (ms). Override via REACT_APP_API_REQUEST_TIMEOUT_MS. */
export const apiRequestTimeoutMs = parseTimeoutMs(
  process.env.REACT_APP_API_REQUEST_TIMEOUT_MS,
  60000
);

/** Longer timeout for file download/upload requests (ms). Override via REACT_APP_API_FILE_REQUEST_TIMEOUT_MS. */
export const apiFileRequestTimeoutMs = parseTimeoutMs(
  process.env.REACT_APP_API_FILE_REQUEST_TIMEOUT_MS,
  120000
);

/** Heavy read endpoints such as dashboard / performance stats (ms). Override via REACT_APP_API_LONG_RUNNING_REQUEST_TIMEOUT_MS. */
export const apiLongRunningRequestTimeoutMs = parseTimeoutMs(
  process.env.REACT_APP_API_LONG_RUNNING_REQUEST_TIMEOUT_MS,
  180000
);

/**
 * Lead import/export (ms). Set just under Azure's 230s front-end (ARR) idle
 * timeout, which is the hard ceiling for a synchronous request — past that the
 * platform returns a 502 regardless. Override via REACT_APP_API_IMPORT_REQUEST_TIMEOUT_MS.
 */
export const apiImportRequestTimeoutMs = parseTimeoutMs(
  process.env.REACT_APP_API_IMPORT_REQUEST_TIMEOUT_MS,
  220000
);

export const wilmaSSODashboardUrl = process.env.REACT_APP_WILMA_SSO_DASHBOARD_URL;
export const wilmaSSOAPIUrl = process.env.REACT_APP_WILMA_SSO_API_URL;
export const wilmaSSOAppRegistration = process.env.REACT_APP_WILMA_SSO_APP_REGISTRATION;
export const wilmaSAVCustomerId = process.env.REACT_APP_WILMA_SAV_CUSTOMER_ID;

export const sentryDSN = process.env.REACT_APP_SENTRY_DSN;
export const sentryReplaySampleRate = parseFloat(process.env.REACT_APP_SENTRY_REPLAY_SAMPLE_RATE || "0.1");
export const sentryReplayOnErrorSampleRate = parseFloat(process.env.REACT_APP_SENTRY_REPLAY_ON_ERROR_SAMPLE_RATE || "1.0");

// export const wilmaPublicCdn = "https://cdn.recyclingsoftware.co.uk/public/images/";

export const tokenStorageKey = "wilma-app-token";

export const rsCustomerIdWhitelist = (process.env.REACT_APP_RS_WHITELISTED_CUSTOMER_IDS || "").split(",")
  .map(id => id.trim().toLowerCase())
  .filter(id => id.length > 0);

export const gtWidgetURL = process.env.REACT_APP_GT_WIDGET_URL || "http://localhost:8080";
